<template>
  <div class="page-content-wrapper">
    <div class="content">
      <div class="container-fluid container-fixed-lg">
        <div class="row p-3">
          <div class="col-lg-12">
            <h2 class="text-dag">{{ $t('menu_settings') }}</h2>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-6 m-b-10">
            <div class="card no-border widget-loader-circle no-padding rounded">
              <div class="card-body p-t-40 p-b-20">

                <div class="card cardion">
                  <div class="card-header cardionhead" id="headingOne">
                    <p class="mb-0 p-1">
                      <b-button class="btn btn-link adviestitle-links"
                              :to="{ name: 'changepassword' }">
                        {{ $t('profile_change_pwd') }}
                      </b-button>
                    </p>
                  </div>
                </div>

                <div class="card cardion">
                  <div class="card-header cardionhead" id="headingOne">
                    <p class="mb-0 p-1">
                      <b-button class="btn btn-link adviestitle-links"
                                :to="{ name: 'changeemail' }">
                        {{ $t('profile_personal_email') }}
                      </b-button>
                    </p>
                  </div>
                </div>

                <div class="p-l-20">
                  <p class="adviestitle">{{ $t('profile_language') }}:</p>
                  <p class="text-muted">
                    <button class="btn btn-link"
                              :disabled="getCurrentLanguage === 'nl'"
                              @click="setLang('nl')">
                      {{ $t('profile_lang_nl') }}<span v-if="getCurrentLanguage === 'nl'"> ({{ $t('profile_current') }})</span>
                    </button> /
                    <button class="btn btn-link"
                              :disabled="getCurrentLanguage === 'en'"
                              @click="setLang('en')">
                      {{ $t('profile_lang_en') }}<span v-if="getCurrentLanguage === 'en'"> ({{ $t('profile_current') }})</span>
                    </button>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  export default {
    computed: {
      ...mapGetters([
        'getCurrentLanguage',
      ]),
    },
    methods: {
      ...mapActions([
        'changeLanguage',
      ]),
      setLang (lang) {
        this.changeLanguage(lang)
      }
    },
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/profile/Settings.vue